export default __webpack_public_path__ + "static/media/blockdate.e97d586d.svg";